import { Modal } from '../components/Modal';
import { AppealList } from '../components/AppealList';

/**
 * Creator's side of the re-review: executors ask to look again at a rejected
 * submission (or at a wrong check word), and the task's creator decides first.
 */
export function AppealReviewModal({ onClose, onChanged }: { onClose: () => void; onChanged?: () => void }) {
    return (
        <Modal title="Пересмотры по вашим заданиям" onClose={onClose}>
            <p className="popup-text text-muted f-12">
                Исполнители просят пересмотреть отклонённые заявки. Если вы откажете,
                исполнитель может обратиться к администрации — повторно решать будет она.
            </p>
            <AppealList mode="creator" onChanged={onChanged} />
        </Modal>
    );
}
